import * as React from 'react'

import { Field } from 'redux-form'

import { Input } from 'components'

const required = value => (value ? undefined : 'Required')
const email = value =>
  value &&
  !/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(
    value
  )
    ? 'Invalid email'
    : undefined

interface IProps {
  onChangeMaskedInput: any
}

export default (props: IProps) => {
  return (
    <form className="signup-form" noValidate={true} autoComplete="off">
      <Field
        props={{
          label: 'First name'
        }}
        name="pName"
        type="text"
        component={Input}
        validate={[required]}
      />
      <Field
        props={{
          label: 'Last name'
        }}
        name="pLastName"
        type="text"
        component={Input}
        validate={[required]}
      />
      <Field
        props={{
          label: 'Email'
        }}
        name="email"
        type="email"
        component={Input}
        validate={[required, email]}
      />
      <Field
        props={{
          label: 'Password'
        }}
        name="password"
        type="password"
        component={Input}
        validate={[required]}
      />
    </form>
  )
}



// WEBPACK FOOTER //
// ./src/pages/SignUp/Parent/form.tsx